import httpClient from '../../shared/services/httpClient';

export const SearchDistrict = async (regionId?: number, cityId?: number) => {
  return await httpClient.get(`/district/region?regionId=${regionId}&cityId=${cityId}`, {
    skipAuth: true,
  });
};
